import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import WelcomeText from "../../assets/headings/welcome-logo.svg";
import Moon from "../../assets/evilMoon.svg";
import MinionNormal from "../../assets/evilMinion.svg";
import "./HeroScene.scss";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

export function HeroScene() {
  const sceneRef = useRef<HTMLElement>(null);
  const normalRef = useRef<HTMLImageElement>(null);

  useGSAP(
    () => {
      const media = gsap.matchMedia();

      media.add("(min-width: 768px) and (prefers-reduced-motion: no-preference)", () => {
        gsap.to(".hero-minion-stage", {
          yPercent: -16,
          ease: "none",
          scrollTrigger: {
            trigger: ".hero-top-panel",
            start: "top bottom",
            end: "bottom top",
            scrub: 0.8,
          },
        });
      });

      return () => media.revert();
    },
    { scope: sceneRef }
  );

  return (
    <section className="hero-scroll-track" id="home" ref={sceneRef}>
      <div className="hero-top-panel">
        <div className="hero-moon-content">
          <img className="hero-moon" src={Moon} alt="" aria-hidden="true" />
          <div className="hero-copy">
            <img className="welcome-text" src={WelcomeText} alt="Welcome to CSCI 0150" />
            <p className="main-description">
              CSCI 0150 is one of the introductory Computer Science courses offered at Brown University.
              <br /><br />
              This course introduces students to Computer Science through object-oriented design and programming,
              using Java and the JavaFX graphics library. You will use these tools for building interactive programs
              with graphical user interfaces. CSCI 0150 reinforces concepts with practical exercises in weekly lab
              sessions and with challenging and engaging programming assignments, such as
              <span className="doodle-color-text"> Doodle Jump</span> and <span className="tetris-color-text">Tetris</span>!
              <br /><br />
              There are no prerequisites for CSCI 0150 and the course expects no prior programming experience.
            </p>
          </div>
        </div>
        <div className="hero-minion-float">
          <div className="hero-minion-stage">
            <img
              className="hero-minion-body hero-minion-body--normal"
              ref={normalRef}
              src={MinionNormal}
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
  );
}
